import { StarterPromotionDecember2025Banner } from 'pricing-pages-ui-components/banners/StarterPromotionDecember2025Banner';
import { useStarterPromoDecember2025Banner } from '../../v2/hooks/banners/useStarterPromoDecember2025Banner';
import { trackBannerInteraction } from '../../v2/utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const StarterPromotionDecember2025BannerWrapper = ({
  screen
}) => {
  const {
    shouldShowBanner
  } = useStarterPromoDecember2025Banner({
    screen
  });
  if (!shouldShowBanner) {
    return null;
  }
  return /*#__PURE__*/_jsx(StarterPromotionDecember2025Banner, {
    trackBannerInteraction: trackBannerInteraction
  });
};
export default StarterPromotionDecember2025BannerWrapper;